import React from "react";
import { UserCheck, UserPlus, CheckCircle, AlertTriangle, Loader2 } from "lucide-react";

const AtivarServicoCard = ({ arrendatario, loadingArrendatario, criandoArrendatario, onCriarArrendatario }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-border flex flex-col h-full">
      <div className="flex items-center gap-3 p-5 border-b border-border bg-slate-50 rounded-t-xl">
        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm">
          {arrendatario ? (
            <UserCheck className="w-5 h-5 text-emerald-500" />
          ) : (
            <UserPlus className="w-5 h-5 text-amber-500" />
          )}
        </div>
        <h2 className="text-base font-semibold text-foreground">Ativar serviço</h2>
      </div>

      <div className="p-5 flex-1">
        <p className="text-sm text-muted-foreground mb-4">
          Ativar o serviço de distribuição para a sua organização
        </p>
        <div className="bg-slate-50 rounded-lg p-3">
          {loadingArrendatario ? (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>Verificando...</span>
            </div>
          ) : arrendatario ? (
            <div className="flex items-center gap-2 text-sm text-emerald-600">
              <CheckCircle className="w-4 h-4" />
              <span>Conta cadastrada</span>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-sm text-amber-600">
              <AlertTriangle className="w-4 h-4" />
              <span>Conta não cadastrada</span>
            </div>
          )}
        </div>
      </div>

      <div className="p-5 border-t border-border">
        {loadingArrendatario ? (
          <button className="w-full py-2 px-4 rounded-md bg-slate-200 text-slate-500 text-sm font-medium cursor-not-allowed" disabled>
            Carregando...
          </button>
        ) : arrendatario ? (
          <button className="w-full py-2 px-4 rounded-md bg-emerald-500 text-white text-sm font-medium cursor-not-allowed opacity-80" disabled>
            Configurado
          </button>
        ) : (
          <button
            className="w-full py-2 px-4 rounded-md bg-amber-500 hover:bg-amber-600 text-white text-sm font-medium transition-colors disabled:opacity-70"
            onClick={onCriarArrendatario}
            disabled={criandoArrendatario}
          >
            {criandoArrendatario ? "Ativando..." : "Ativar conta"}
          </button>
        )}
      </div>
    </div>
  );
};

export default AtivarServicoCard;
